import { useHistory } from "react-router-dom";
import React from "react";
import { Button } from "@mui/material";
import { s3BaseUrl } from "../../config/envConfig";

const InvalidLinkMessage = ({ windowWidth, errorMessage }) => {
  const history = useHistory();

  const goToLogin = () => {
    history.push("/login");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: windowWidth >= 800 ? "50%" : "80%",
      }}
    >
      <div>
        <img
          src={
            s3BaseUrl + "/mobitutorza_logo_full.png"
          }
          alt={"MobiTutorZA Logo"}
          width={"250px"}
          height={"250px"}
        />
      </div>

      <div>
        <p style={{ color: "white", fontSize: "1.25em", fontWeight: "bold" }}>
          Security
        </p>
        <hr style={{ color: "white", width: "100%", marginBottom: "20px" }} />
      </div>

      <div>
        <p
          style={{
            marginTop: "0px",
            fontWeight: "bold",
            color: "rgb(251, 205, 2)",
            padding: "5px",
            textAlign: "center",
            fontSize: "1.1rem",
          }}
        >
          {errorMessage || "Invalid registration link. This link is not valid or has been tampered with."}
        </p>

        <Button
          variant="contained"
          style={{
            backgroundColor: "#FBCD02",
            color: "#00112e",
            width: "100%",
            height: "3.2em",
            fontWeight: "bold",
          }}
          onClick={goToLogin}
        >
          Go to Login
        </Button>
      </div>
    </div>
  );
};

export default InvalidLinkMessage; 